import api from '@/lib/base-api'
import type { BundleChoicesResponse, BundleGroup, FolderChoice, SessionCategoryChoice, UserAttribute } from '@/types'
import { create } from 'zustand'

interface SelectOption {
  value: string
  label: string
}

interface BundleChoiceState {
  groups: BundleGroup[]
  folders: FolderChoice[]
  groupOptions: SelectOption[]
  sessionCategories: SessionCategoryChoice[]
  userAttributes: UserAttribute[]
  isLoaded: boolean
  fetch: () => Promise<void>
  refresh: () => void
}

export const NORMAL_USER_GROUP_NAME = 'Normal User'

export const useBundleChoiceStore = create<BundleChoiceState>((set, get) => ({
  groups: [],
  folders: [],
  groupOptions: [],
  sessionCategories: [],
  userAttributes: [],
  isLoaded: false,
  fetch: async () => {
    if (get().isLoaded) return
    try {
      const data = await api.get<BundleChoicesResponse>('/api/common/bundle-choices')
      set({
        groups: data.groups,
        folders: data.folders ?? [],
        groupOptions: data.groups.map((g) => ({ value: String(g.id), label: g.name })),
        sessionCategories: data.session_categories ?? [],
        userAttributes: data.user_attributes ?? [],
        isLoaded: true,
      })
    } catch {
      set({ isLoaded: true })
    }
  },
  refresh: () => {
    set({ isLoaded: false })
    get().fetch()
  },
}))
